export default "<app-header>\n</app-header>    \n\n<div id=\"master-container\">\n  <router-outlet></router-outlet>\n</div>\n\n\n";